import { takeEvery, takeLatest } from 'redux-saga/effects';
import {
  CREATE_SETTINGS, DELETE_SETTINGS, EDIT_SETTINGS, LOAD_SETTING_BY_ID, LOAD_SETTINGS,
} from '../actions';
import { SETTINGS_MODULE } from '../../../configs/moduleNames';

import createSettings from './createSettings';
import deleteSettings from './deleteSettings';
import editSettings from './editSettings';
import loadSettingById from './loadSettingById';
import loadSettings from './loadSettings';

export default function* watchSystem() {
  yield takeEvery(SETTINGS_MODULE + CREATE_SETTINGS, createSettings);
  yield takeEvery(SETTINGS_MODULE + DELETE_SETTINGS, deleteSettings);
  yield takeEvery(SETTINGS_MODULE + EDIT_SETTINGS, editSettings);
  yield takeEvery(SETTINGS_MODULE + LOAD_SETTING_BY_ID, loadSettingById);
  yield takeLatest(SETTINGS_MODULE + LOAD_SETTINGS, loadSettings);
}
